import { Expose } from "class-transformer";

export class AssignPlanningBoardLoanVehicleDto {
  @Expose()
  vehicleId: string;
}
